import React, { useState } from 'react';
import axios from 'axios'; // Make sure axios is installed
import './Sec10Contactform.css';
import Cookies from 'js-cookie';

const Sec10Contactform = () => {
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({});

    const validate = () => {

        let newErrors = {};
        if (!formData.fullName) newErrors.fullName = 'Full Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email address is invalid';
        if (!formData.message) newErrors.message = 'Message is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };
    // console.log('Form data submitted:', formData);

    const handleSubmit = (e) => {
        e.preventDefault();

        const searchParams = new URLSearchParams(window.location.search);
        const utm_source = (!(searchParams.get('utm_source'))?'na':searchParams.get('utm_source'));
        const utm_campaign = (!(searchParams.get('utm_campaign'))?'na':searchParams.get('utm_campaign'));
        const utm_medium = (!(searchParams.get('utm_medium'))?'na':searchParams.get('utm_medium'));
        const utm_term = (!(searchParams.get('utm_term'))?'na':searchParams.get('utm_term'));
        const utm_content = (!(searchParams.get('utm_content'))?'na':searchParams.get('utm_content'));
        const hubspotutkCookie = Cookies.get('hubspotutk');

        if (validate()) {

            // Form submission logic 
            // console.log('Form submitted:', formData);
            const full_name_str = formData.fullName.split(" ");
            var firstName = '';
            var lastName = '';
            if(full_name_str.length>0){
                firstName = full_name_str[0];
                for(var i=1;i<full_name_str.length;i++){
                lastName+=full_name_str[i]+' ';
                }
                
            }else{
                firstName = formData.fullName;
            }
            // console.log("First Name "+firstName);
            // console.log("Last Name "+lastName);
            // console.log("UTM Source "+utm_source);
            // console.log("UTM Medium "+utm_medium);
            // console.log("UTM Campaign "+utm_campaign);

            var data = {
                "submittedAt": Date.now(),
                "fields": [
                  {
                    "objectTypeId": "0-1",
                    "name": "firstname",
                    "value": firstName
                  },
                  ...(lastName ? [{ objectTypeId: '0-1', name: 'lastname', value: lastName }] : []),
                  {
                    "objectTypeId": "0-1",
                    "name": "email",
                    "value": formData.email
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "message",
                    "value": formData.message
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "page_url",
                    "value": window.location.href
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "utm_campaign",
                    "value": utm_campaign
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "utm_content",
                    "value": utm_content
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "utm_medium",
                    "value": utm_medium
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "utm_source",
                    "value": utm_source
                  },
                  {
                    "objectTypeId": "0-1",
                    "name": "utm_term",
                    "value": utm_term
                  }
                ],
                "context": {
                      "hutk": hubspotutkCookie, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
                      "pageUri": window.location.href,
                      "pageName": document.getElementsByTagName("title")[0].innerHTML
                 }
              }
          
              var final_data = JSON.stringify(data);

            axios.post('https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/contact_form.php', final_data)
                .then(response => {
                    // console.log('Form data submitted:', response.data);
                    // Reset the form fields
                    // setFormData({
                    //     fullName: '',
                    //     email: '',
                    //     message: ''
                    // });
                    // setErrors({});
                    window.location.href = 'https://zinnov.com/contact-us/thank-you/';
                })
                .catch(error => {
                    // console.error('Error submitting form data:', error);
                });

            //formv3(firstName,lastName,formData.email,formData.message,utm_campaign,utm_medium,utm_source,utm_term,utm_content);
            //navigate('/thank-you',{state: {firstName: firstName, lastName: lastName, email: formData.email, utm_campaign: utm_campaign, utm_medium: utm_medium, utm_source: utm_source, utm_term: utm_term, utm_content: utm_content,whichform: 'contact form'}});

            // Clear form data
            setFormData({
                fullName: '',
                email: '',
                message: ''
            });
            // Clear errors
            setErrors({});

        }
    };

    return (
        <form className="contact-form container" onSubmit={handleSubmit}>
            <h3>SPEAK WITH <br /> OUR CONSULTANTS</h3>
            <div className="form-group">
                <input
                    className={`box icon ${errors.fullName ? 'error' : ''}`}
                    type="text"
                    id="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                    placeholder="Full Name"
                />
                {errors.fullName && <div className="error-message">{errors.fullName}</div>}
            </div>
            <div className="form-group">
                <input
                    className={`box icon ${errors.email ? 'error' : ''}`}
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email"
                />
                {errors.email && <div className="error-message">{errors.email}</div>}
            </div>
            <div className="form-group">
                <textarea
                    className={`box msg ${errors.message ? 'error' : ''}`}
                    id="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Message"
                ></textarea>
                {errors.message && <div className="error-message">{errors.message}</div>}
            </div>
            <div className="form-group">
                <button
                    id="button"
                    className="box"
                    type="submit"
                >
                    Get Started
                </button>
            </div>
        </form>
    );
};

export default Sec10Contactform;
